import Vue from 'vue';

Vue.filter('currency', (val: number | string) => {
	if (!val) return '';
	const value = typeof val === 'string' ? parseFloat(val) : val;
	const formatter = new Intl.NumberFormat('it-IT', {
		style: 'currency',
		currency: 'EUR',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	});
	return formatter.format(value);
});

Vue.filter('decimals', (val: number | string, decimals: number) => {
	if (!val) return '';
	const value = typeof val === 'string' ? parseFloat(val) : val;
	const formatter = new Intl.NumberFormat('it-IT', {
		maximumFractionDigits: decimals
	});
	return formatter.format(value);
});